<div class="mb-1">
  <h6 class="mb-3" i18n>{{ catalogSku().availableQuantity }} Verfügbar</h6>
</div>
<div class="row mb-2 float-end">
  @if (CanAddToCart()) {
    <div class="col-sm-10">
      <div class="input-group mb-3">
        <span class="input-group-text" id="basic-addon3" i18n>Menge</span>
        <input
          [(ngModel)]="count"
          id="count"
          type="number"
          class="form-control"
          aria-describedby="basic-addon3"
          style="max-width: 50px;"
          />
        <button class="btn btn-sm btn-primary align-middle mt-2" data-testid="add-to-cart-button" [asyncClick]="addToCart.bind(this)" [disabled]="addBtn.disabled" #addBtn="asyncClick" type="button" i18n>
        @if (addBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
        In den Warenkorb
      </button>
      </div>
    </div>
  }
</div>
